import React, { useContext, useState, useEffect } from 'react'
import { getUrl } from '../firebase/storage'

import Store, { IStore } from '../store'
import StoreCode, { IStoreCode } from '../contexts/StoreCodeContext'
import Offset, { IOffsetContext } from '../contexts/OffsetContext'
import PopupPanel, { IPopupPanel } from '../contexts/PopupPanelContext'

export function useStore() {
	const store = useContext(Store) as IStore
	return store
}

export function useStoreCode() {
	const storeCode = useContext(StoreCode) as IStoreCode
	return storeCode
}

export function usePopupPanel() {
	const popupPanel = useContext(PopupPanel) as IPopupPanel
	return popupPanel
}

export function useOffset() {
	const offset = useContext(Offset) as IOffsetContext
	return offset
}

export function useUrl(path) {
	const [url, setUrl] = useState()

	useEffect(() => {
		try {
			if (path) getUrl(path).then(setUrl).catch(console.log)
		} catch { }
	}, [path])

	return url
}
